import { render } from "./Multicat.vue?vue&type=template&id=94cf98ba&scoped=true"
import script from "./Multicat.vue?vue&type=script&lang=js"
export * from "./Multicat.vue?vue&type=script&lang=js"

import "./Multicat.vue?vue&type=style&index=0&id=94cf98ba&scoped=true&lang=css"

import exportComponent from "/home/runner/work/metal-client/metal-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94cf98ba"]])

export default __exports__